export default [
    'company.administrators',
    'company.administrators.add',
    'company.applications',
    'company.computer-protection',
    'company.corporate-settings',
    'company.custom-app-integration',
    'company.directory-integration',
    'company.directory-integration.add-active-directory',
    'company.domains',
    'company.google-hangouts-bot',
    'company.google-marketplace-instructions',
    'company.hard-token-management',
    'company.landing-page',
    'company.recovery',
    'company.reports-administrator-audit',
    'company.reports-application-usage',
    'company.reports-computers',
    'company.reports-main',
    'company.reseller',
    'company.reseller.add-new-company',
    'company.resources',
    'company.roles-help',
    // 'company.saaspass-vpn',
    'company.saaspass-connect',
    'company.sharing-center',
    'company.sharing-center.shared-accounts',
    'company.sharing-center.shared-authenticators',
    'company.sharing-center.shared-passwords',
    'company.slack-info',
    'company.sms-services',
    'company.sms-services.help',
    'company.sms-services.help.how-to-add-sms-user',
    'company.sms-services.help.sms-credit',
    'company.sms-services.help.sms-settings',
    'company.sms-services.help.what-is-sms-service',
    'company.supported-application-types',
    'company.supported-epm-types',
    'company.user-directories.directory-groups',
    'company.user-directories.directory-groups.all-accounts',
    'company.user-directories.directory-groups.all-accounts.verify',
    'company.user-directories.directory-groups.directory.add-new-group',
    'company.user-directories.directory-groups.directory.add-user',
    'company.user-directories.directory-groups.directory.import-users',
    'company.user-directories.saaspass-users',
    'company.user-directories.saaspass-users.administrators-developers',
    'company.user-directories.saaspass-users.all-users',
    'company.user-directories.saaspass-users.blocked-users',
    'company.user-directories.saaspass-users.hard-token-users',
    'company.user-directories.saaspass-users.regular-saaspass-app-users',
    'company.user-directories.saaspass-users.sms-users',
    'company.user-directories.saaspass-users.sms-users.add',
    'company.user-directories.saaspass-users.user-settings',
    'company.whats-new',
    'gmp-config',
    'public.company-registration',
    'public.contact',
    'public.email-verification',
    'public.extension-alert',
    'public.google-info',
    'public.hard-token-login',
    'public.hard-token-sync',
    'public.login',
    'public.logout',
    'public.pin-reset',
    'public.sms-user-otp',
    'public.sms-user-registration',
    'user',
    'user.applications',
    'user.connectors',
    'user.device-management',
    'user.emails',
    'user.mobile-numbers',
    'user.mobile-numbers.add',
    'user.mobile-numbers.recovery-settings',
    'user.public.user-accounts',
    'user.public.user-accounts.import',
    'user.profiles',
    'user.shared-accounts',
    'user.statistics',
];



// WEBPACK FOOTER //
// ./src/portal/components/sp-global-search/states.js